import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, Collapse } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import actions from 'actions';
import sh from 'components/shared.module.css';
import Options from '../Options/Options';
import s from './pagination.module.css';

const { updateViewOption, updateMapOption } = actions;

const B = ({ t }) => <span className='font-weight-bold'>{t}</span>;

const Showing = ({ itemFirst, itemLast, itemNum, bucketNum }) => (
  <span className={`ml-4 ${s.showingCont}`}>
    {'Showing: ('}
    {<B t={itemFirst} />}
    {' - '}
    {<B t={itemLast} />}
    {') / '}
    <B t={itemNum} />
    {' objects in ('}
    <B t={bucketNum} />
    {' bucket)'}
  </span>
);

// check if p == 0 or < 0 or == pageNow - remove onClick if disabled
const C = ({ p, children, disabled }) => <span className={`${s.pageItem} ${(disabled) ? s.disabled : ''}`} onClick={() => {/* p: todo page to redirect*/console.log(p) }}>{children}</span>;

const Pages = ({ pageNow, lastPage }) => (
  <div className={s.pagesCont}>
    <C p={1} disabled={(pageNow === 1)}>«</C>
    <C p={(pageNow - 1)} disabled={(pageNow === 1)}>‹</C>
    <input value={pageNow} readOnly className={s.pagesInput} style={{ marginLeft: 6 }} />
    {` / ${lastPage}`}
    <C p={(lastPage - 1)} disabled={(pageNow === lastPage)}><span style={{ marginLeft: 6 }}>›</span></C>
    <C p={lastPage} disabled={(pageNow === lastPage)}>»</C>
  </div>
);

const Search = () => (
  <div className={`d-flex ${s.searchCont}`}>
    <input className={s.search} type='text' placeholder='Search..' />
    <FontAwesomeIcon icon={['fas', 'search']} className={s.searchIcon} />
  </div>
);

const OptionsDropdown = ({ collapsed, children }) => {
  const [isCollapsed, toggleCollapse] = useState(collapsed);
  return (
    <div className='ddt' style={{ position: 'relative' }}>
      <FontAwesomeIcon icon={['fas', 'cog']} className={s.optionsIcon} onClick={() => toggleCollapse(!isCollapsed)} />
      <Collapse in={isCollapsed} timeout={0}>
        {children}
      </Collapse>
    </div>
  );
};

const Dropdowns = ({ tabId, geo, showJustTheMap, dispatch }) => (
  <div className={s.optionsIconCont} style={(geo === 'Yes') ? { width: 75 } : {}}>
    <div className='d-flex mr-1' style={{ height: 22, marginTop: 2 }}>
      {(geo === 'Yes') && <FontAwesomeIcon icon={['fas', 'map']} className={s.optionsIcon} style={{ marginTop: 1 }} onClick={() => dispatch(updateMapOption({ tabId, showJustTheMap: !showJustTheMap }))} />}
      <OptionsDropdown>
        <div className={s.dropdownOptionsCont}>
          <Options />
        </div>
      </OptionsDropdown>
      <Dropdown>
        <Dropdown.Toggle as='div' className='ddt'>
          <FontAwesomeIcon icon={['fas', 'th-list']} className={s.optionsIcon} />
        </Dropdown.Toggle>
        <Dropdown.Menu className={s.dropdownMenuCont}>
          {/* TODO: add styling plus media queries */}
          <Dropdown.Item onClick={() => dispatch(updateViewOption({ tabId, option: 'titlesAndImages' }))}>image and text</Dropdown.Item>
          <Dropdown.Item onClick={() => dispatch(updateViewOption({ tabId, option: 'imagesOnly' }))}>only image</Dropdown.Item>
          <Dropdown.Item onClick={() => dispatch(updateViewOption({ tabId, option: 'titlesOnly' }))}>only text</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  </div>
);

// todo: get bucketNum and other things from global state
const PaginationHeader = ({ itemFirst, itemLast, itemNum, bucketNum, tabId, geo, showJustTheMap }) => {
  const dispatch = useDispatch();
  return (
    <div className={`${sh.headerCategory} ${s.pagHeaderCont}`}>
      {/* TODO: check cases this is changing (eg buckets ?) */}
      <Showing {...{ itemFirst, itemLast, itemNum, bucketNum }} />
      <Pages pageNow={1} lastPage={3} />
      <Search />
      <Dropdowns {...{ tabId, geo, showJustTheMap, dispatch }} />
    </div>
  );
};

export default PaginationHeader;
